import React, { useEffect, useState } from "react";
import {
  getwaitingOrdersApi,
  sendWatingToIdPayPostApi,
} from "../../Api/BarestServices";
import { separate } from "../../Seprate/Seprate";
import Style from "./WaitingForPay.module.css";
import Timer from "../../Component/Timer/Timer";
import { PointSpreadLoading } from "react-loadingg";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStore,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  ArrowLeftShort,
  ArrowRepeat,
  CreditCard,
  ClockHistory,
  CardList,
  CheckCircleFill,
  ExclamationTriangleFill,
} from "react-bootstrap-icons";
import { errorToast } from "../../Toast/Toast";
import { Button, Modal } from "antd";
import OrderPerviewList from "../../Component/OrderPerviewList/OrderPerviewList";

const WaitingForPay = () => {
  const [data, setData] = useState(null);
  const [disable, setDisable] = useState(false);
  const [payingOrderId, setPayingOrderId] = useState(null);
  const [modalState, setModalState] = useState(false);
  const [modalTitle, setModalTitle] = useState("لیست اقلام سفارش");
  const [orderDataState, setOrderDataState] = useState([]);

  useEffect(() => {
    getWaitingOrders();
  }, []);

  const getWaitingOrders = () => {
    getwaitingOrdersApi((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setData(res);
        }
      } else {
        console.error(res);
      }
    });
  };

  // Link to IdPay
  const sendToIdPay = (id) => {
    setDisable(true);
    setPayingOrderId(id);
    const info = {
      order_id: id,
    };
    sendWatingToIdPayPostApi(info, (res) => {
      setDisable(false);
      setPayingOrderId(null);
      if (res && res.link) {
        window.open(res.link, "_self");
      } else if (res && res.message) {
        errorToast(res.message);
      } else {
        errorToast("مشکلی در ایجاد درگاه پرداخت به وجود آمد");
      }
    });
  };

  const ordersList = Array.isArray(data?.orders) ? data.orders : [];
  const payMoreList = Array.isArray(data?.pay_more) ? data.pay_more : [];

  const isLoading =
    !data || (data.orders === undefined && data.pay_more === undefined);
  const isEmpty = !isLoading && ordersList.length === 0 && payMoreList.length === 0;

  // Clean supplier name from markdown asterisks if any
  const cleanName = (name) => {
    if (!name) return "";
    return name.replace(/\*\*/g, "").trim();
  };

  let content = null;

  if (isLoading) {
    content = (
      <div className={Style.loading}>
        <PointSpreadLoading color={"#ab0c59"} size={"small"} />
      </div>
    );
  } else if (isEmpty) {
    content = (
      <div className={Style.NotOrderFoundHolder}>
        <div className={Style.ImageBasket}>
          <img src="/Assets/Images/Order/not2.png" alt="بدون سفارش" />
        </div>
        <h3 className={Style.emptyTitle}>سفارشی در انتظار پرداخت وجود ندارد</h3>
        <p className={Style.emptySubtitle}>
          کلیه سفارش‌های شما تکمیل شده یا فاکتور بازی برای پرداخت وجود ندارد.
        </p>
      </div>
    );
  } else {
    content = (
      <>
        {/* Modal for viewing order items */}
        <Modal
          title={modalTitle}
          open={modalState}
          closable={false}
          onCancel={() => setModalState(false)}
          destroyOnClose
          width="92%"
          style={{ direction: "rtl", maxWidth: "500px", margin: "20px auto" }}
          footer={<div className={Style.ConfirmProductModal}><Button className={Style.viewItemsBtn} onClick={() => setModalState(false)}>تایید</Button></div>}
        >
          <OrderPerviewList data={orderDataState} />
        </Modal>

        {/* Section 1: Pay More Orders (Price/Quantity Updates by Supplier) */}
        {payMoreList.length > 0 && (
          <div className={Style.sectionContainer}>
            <div className={Style.sectionHeader}>
              <div className={Style.sectionTitleWrapper}>
                <span className={Style.dotAmber}></span>
                <h2 className={Style.sectionTitle}>
                  سفارش‌های نیازمند پرداخت مابه‌التفاوت
                </h2>
              </div>
              <span className={Style.badgeCountAmber}>
                {payMoreList.length} سفارش
              </span>
            </div>

            {payMoreList.map((item, index) => {
              const total = parseInt(item.total || 0);
              const paied = parseInt(item.paied || 0);
              const remainingToPay = Math.max(0, total - paied);
              const deliveryPrice = parseInt(item.delivery_price || 0);
              const isPayingThis = payingOrderId === item.id;

              return (
                <div key={item.id || index} className={Style.orderCard}>
                  {/* Card Header */}
                  <div className={Style.cardHeaderPayMore}>
                    <div className={Style.headerRight}>
                      <span className={Style.orderIdText}>
                        سفارش #{item.id}
                      </span>
                      <span className={Style.statusTagAmber}>
                        اصلاح قیمت/تعداد توسط فروشگاه
                      </span>
                    </div>
                  </div>

                  {/* Warning Notice */}
                  <div className={Style.warningNotice}>
                    <ExclamationTriangleFill className={Style.warningIcon} />
                    <span>
                      فروشگاه برخی اقلام را از نظر قیمت یا تعداد به‌روزرسانی کرده است.
                      برای نهایی شدن و ارسال سفارش، لطفاً مبلغ مابه‌التفاوت را پرداخت فرمایید.
                    </span>
                  </div>

                  {/* Carts & Suppliers */}
                  {item.carts?.map((cart, cartIndex) => {
                    return (
                      <div key={cartIndex}>
                        <div className={Style.supplierBlock}>
                          <div className={Style.supplierRight}>
                            <img
                              className={Style.supplierLogo}
                              src={`//cdn.barest.ir/supplier/logo/${cart.logo}.jpg`}
                              alt={cart.name || "فروشگاه"}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "/Assets/Images/Order/not2.png";
                              }}
                            />
                            <div className={Style.supplierDetails}>
                              <h3 className={Style.supplierName}>
                                <FontAwesomeIcon
                                  icon={faStore}
                                  className={Style.storeIcon}
                                />
                                {cleanName(cart.name)}
                              </h3>
                              {cart.address && (
                                <p className={Style.supplierAddress}>
                                  <FontAwesomeIcon
                                    icon={faMapMarkerAlt}
                                    style={{ marginLeft: "4px", color: "#9ca3af" }}
                                  />
                                  {cart.address}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Changed Products list */}
                        {cart.products && cart.products.length > 0 && (
                          <div className={Style.productsSection}>
                            <h4 className={Style.productsSectionTitle}>
                              <span>اقلام تغییر یافته:</span>
                              <span style={{ fontSize: "0.74rem", color: "#6b7280" }}>
                                {cart.products.length} قلم
                              </span>
                            </h4>

                            {cart.products.map((product, pIndex) => {
                              const oldPrice = parseInt(product.price || 0, 10);
                              const newPrice = parseInt(product.new_price || 0, 10);
                              const priceDiff = newPrice - oldPrice;
                              const isPriceChanged =
                                product.price !== undefined &&
                                product.new_price !== undefined &&
                                oldPrice !== newPrice;

                              const oldCount = parseInt(product.count || 0, 10);
                              const newCount = parseInt(product.new_count || 0, 10);
                              const countDiff = newCount - oldCount;
                              const isCountChanged =
                                product.count !== undefined &&
                                product.new_count !== undefined &&
                                oldCount !== newCount;

                              const isProductChanged = Boolean(
                                product.p_product_id &&
                                String(product.p_product_id) !== "0"
                              );

                              const hasDifferentImg =
                                isProductChanged &&
                                product.p_product_id &&
                                String(product.p_product_id) !== "0" &&
                                String(product.p_product_id) !== String(product.product_id);

                              const isOutOfStock = product.availability === "0";

                              return (
                                <div
                                  key={pIndex}
                                  className={`${Style.productItem} ${
                                    isProductChanged ? Style.productItemChanged : ""
                                  }`}
                                >
                                  {/* Thumbnail Area */}
                                  <div className={Style.thumbArea}>
                                    {hasDifferentImg ? (
                                      <div className={Style.thumbsCompareWrapper}>
                                        <div
                                          className={Style.thumbBoxOld}
                                          title={`کالای قبلی: ${product.p_name || ""}`}
                                        >
                                          <img
                                            className={Style.oldProductThumb}
                                            src={`//cdn.barest.ir/product/m/${product.p_product_id}.jpg`}
                                            alt={product.p_name || "محصول قبلی"}
                                            onError={(e) => {
                                              e.target.style.display = "none";
                                            }}
                                          />
                                          <span className={Style.thumbBadgeOld}>قبل</span>
                                        </div>
                                        <ArrowLeftShort className={Style.thumbCompareArrow} />
                                        <div
                                          className={Style.thumbBoxNew}
                                          title={`کالای جدید: ${product.name}`}
                                        >
                                          <img
                                            className={Style.productThumb}
                                            src={`//cdn.barest.ir/product/m/${product.product_id}.jpg`}
                                            alt={product.name}
                                            onError={(e) => {
                                              e.target.style.display = "none";
                                            }}
                                          />
                                          <span className={Style.thumbBadgeNew}>جدید</span>
                                        </div>
                                      </div>
                                    ) : (
                                      <img
                                        className={Style.productThumb}
                                        src={`//cdn.barest.ir/product/m/${product.product_id}.jpg`}
                                        alt={product.name}
                                        onError={(e) => {
                                          e.target.style.display = "none";
                                        }}
                                      />
                                    )}
                                  </div>

                                  <div className={Style.productInfo}>
                                    {/* Product Name / Change */}
                                    {isProductChanged ? (
                                      <div className={Style.productReplacementBox}>
                                        <div className={Style.replacementTag}>
                                          <ArrowRepeat className={Style.replacementTagIcon} />
                                          <span>تغییر کالا توسط فروشگاه</span>
                                        </div>
                                        <div className={Style.nameTransitionRow}>
                                          <div className={Style.nameStepOld}>
                                            <span className={Style.nameStepPrefix}>قبلی:</span>
                                            <span
                                              className={Style.oldNameText}
                                              title={product.p_name}
                                            >
                                              {product.p_name || "محصول قبلی"}
                                            </span>
                                          </div>
                                          <ArrowLeftShort className={Style.nameTransitionArrow} />
                                          <div className={Style.nameStepNew}>
                                            <span className={Style.nameStepPrefixNew}>جدید:</span>
                                            <span
                                              className={Style.newNameText}
                                              title={product.name}
                                            >
                                              {product.name}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                      <h5 className={Style.productName}>{product.name}</h5>
                                    )}

                                    {/* Changes Comparison Row */}
                                    <div className={Style.productChangesRow}>
                                      {/* Price Comparison */}
                                      <div
                                        className={`${Style.changeBadge} ${
                                          isPriceChanged ? Style.changeBadgeActive : ""
                                        }`}
                                      >
                                        <span className={Style.changeBadgeLabel}>قیمت:</span>
                                        {isPriceChanged ? (
                                          <>
                                            <span className={Style.oldValue}>
                                              {separate(oldPrice)}
                                            </span>
                                            <ArrowLeftShort className={Style.arrowIcon} />
                                            <span className={Style.newValuePrice}>
                                              {separate(newPrice)} تومان
                                            </span>
                                            {priceDiff > 0 ? (
                                              <span className={Style.diffPriceChipUp}>
                                                +{separate(priceDiff)}
                                              </span>
                                            ) : priceDiff < 0 ? (
                                              <span className={Style.diffPriceChipDown}>
                                                {separate(priceDiff)}
                                              </span>
                                            ) : null}
                                          </>
                                        ) : (
                                          <span className={Style.newValuePrice}>
                                            {separate(newPrice || oldPrice)} تومان
                                          </span>
                                        )}
                                      </div>

                                      {/* Count Comparison */}
                                      <div
                                        className={`${Style.changeBadge} ${
                                          isCountChanged ? Style.changeBadgeActive : ""
                                        }`}
                                      >
                                        <span className={Style.changeBadgeLabel}>تعداد:</span>
                                        {isCountChanged ? (
                                          <>
                                            <span className={Style.oldValue}>
                                              {oldCount}
                                            </span>
                                            <ArrowLeftShort className={Style.arrowIcon} />
                                            <span className={Style.newValueCount}>
                                              {newCount} عدد
                                            </span>
                                            {countDiff > 0 ? (
                                              <span className={Style.diffCountChipUp}>
                                                +{countDiff}
                                              </span>
                                            ) : countDiff < 0 ? (
                                              <span className={Style.diffCountChipDown}>
                                                {countDiff}
                                              </span>
                                            ) : null}
                                          </>
                                        ) : (
                                          <span className={Style.newValueCount}>
                                            {newCount || oldCount} عدد
                                          </span>
                                        )}
                                      </div>

                                      {/* Out of Stock / Availability */}
                                      {isOutOfStock && (
                                        <span className={Style.outOfStockBadge}>
                                          ناموجود شده
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}

                  {/* Financial Summary */}
                  <div className={Style.financialSummary}>
                    <div className={Style.summaryRow}>
                      <span className={Style.summaryLabel}>
                        مبلغ کل فاکتور جدید:
                      </span>
                      <span className={Style.summaryValue}>
                        {separate(total)} تومان
                      </span>
                    </div>

                    <div className={Style.summaryRow}>
                      <span className={Style.summaryLabel}>
                        مبلغ پرداخت‌شده قبلی:
                      </span>
                      <span className={Style.alreadyPaidValue}>
                        <CheckCircleFill className={Style.paidCheckIcon} />
                        {separate(paied)} تومان
                      </span>
                    </div>

                    {deliveryPrice > 0 && (
                      <div className={Style.summaryRow}>
                        <span className={Style.summaryLabel}>هزینه پیک / ارسال:</span>
                        <span className={Style.summaryValue}>
                          {separate(deliveryPrice)} تومان
                        </span>
                      </div>
                    )}

                    <div className={Style.divider} />

                    <div className={Style.payableRow}>
                      <div className={Style.payableLabelGroup}>
                        <span className={Style.payableTitle}>
                          مابه‌التفاوت قابل پرداخت:
                        </span>
                        <span className={Style.payableSubtitle}>
                          مبلغ مورد نیاز برای ارسال سفارش
                        </span>
                      </div>
                      <span className={Style.payableAmount}>
                        {separate(remainingToPay)} <small>تومان</small>
                      </span>
                    </div>
                  </div>

                  {/* Payment Button */}
                  <div className={Style.cardFooter}>
                    <button
                      className={Style.payButton}
                      onClick={() => sendToIdPay(item.id)}
                      disabled={disable}
                    >
                      <CreditCard className={Style.btnIcon} />
                      <span>
                        {isPayingThis
                          ? "در حال انتقال به درگاه..."
                          : `پرداخت مابه‌التفاوت (${separate(remainingToPay)} تومان)`}
                      </span>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Section 2: Regular Unpaid Orders (Failed / Pending Payment) */}
        {ordersList.length > 0 && (
          <div className={Style.sectionContainer}>
            <div className={Style.sectionHeader}>
              <div className={Style.sectionTitleWrapper}>
                <span className={Style.dotPink}></span>
                <h2 className={Style.sectionTitle}>
                  سفارش‌های در انتظار پرداخت
                </h2>
              </div>
              <span className={Style.badgeCountPink}>
                {ordersList.length} سفارش
              </span>
            </div>

            {ordersList.map((item, index) => {
              const itemTotal = parseInt(item.total || 0);
              const itemDelivery = parseInt(item.delivery_price || 0);
              const itemDiscount = parseInt(item.discount_amount || 0);
              const finalPayable = Math.max(
                0,
                itemTotal + itemDelivery - itemDiscount
              );
              const isPayingThis = payingOrderId === item.id;

              return (
                <div key={item.id || index} className={Style.orderCard}>
                  {/* Card Header */}
                  <div className={Style.cardHeaderOrders}>
                    <div className={Style.headerRight}>
                      <span className={Style.orderIdText}>
                        سفارش #{item.id}
                      </span>
                      <span className={Style.statusTagPink}>
                        در انتظار پرداخت
                      </span>
                    </div>

                    <div className={Style.headerLeft}>
                      {item.remaining_time && item.remaining_time > 0 ? (
                        <div className={Style.timerWrapper}>
                          <ClockHistory />
                          <Timer Time={item.remaining_time} />
                        </div>
                      ) : null}
                    </div>
                  </div>

                  {/* Carts & Suppliers */}
                  {item.carts?.map((cart, cartIndex) => {
                    const productsCount = cart.products?.length || 0;

                    return (
                      <div key={cartIndex} className={Style.supplierBlock}>
                        <div className={Style.supplierRight}>
                          <img
                            className={Style.supplierLogo}
                            src={`//cdn.barest.ir/supplier/logo/${cart.logo}.jpg`}
                            alt={cart.name || "فروشگاه"}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/Assets/Images/Order/not2.png";
                            }}
                          />
                          <div className={Style.supplierDetails}>
                            <h3 className={Style.supplierName}>
                              <FontAwesomeIcon
                                icon={faStore}
                                className={Style.storeIcon}
                              />
                              {cleanName(cart.name)}
                            </h3>
                            {cart.address && (
                              <p className={Style.supplierAddress}>
                                <FontAwesomeIcon
                                  icon={faMapMarkerAlt}
                                  style={{ marginLeft: "4px", color: "#9ca3af" }}
                                />
                                {cart.address}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* View Order Products Button */}
                        <button
                          type="button"
                          className={Style.viewItemsBtn}
                          onClick={() => {
                            setModalTitle(
                              `اقلام سفارش ${cleanName(cart.name)}`
                            );
                            setOrderDataState(cart.products || []);
                            setModalState(true);
                          }}
                        >
                          <CardList />
                          <span>اقلام ({productsCount})</span>
                        </button>
                      </div>
                    );
                  })}

                  {/* Financial Summary */}
                  <div className={Style.financialSummary}>
                    <div className={Style.summaryRow}>
                      <span className={Style.summaryLabel}>قیمت اقلام:</span>
                      <span className={Style.summaryValue}>
                        {separate(itemTotal)} تومان
                      </span>
                    </div>

                    <div className={Style.summaryRow}>
                      <span className={Style.summaryLabel}>هزینه پیک / ارسال:</span>
                      <span className={Style.summaryValue}>
                        {itemDelivery > 0
                          ? `${separate(itemDelivery)} تومان`
                          : "رایگان"}
                      </span>
                    </div>

                    {item.discount_code && item.discount_code !== "" && (
                      <div className={Style.summaryRow}>
                        <span className={Style.summaryLabel}>کد تخفیف:</span>
                        <span className={Style.discountCodeBadge}>
                          {item.discount_code}
                        </span>
                      </div>
                    )}

                    {itemDiscount > 0 && (
                      <div className={Style.summaryRow}>
                        <span className={Style.summaryLabel}>تخفیف:</span>
                        <span className={Style.discountValue}>
                          - {separate(itemDiscount)} تومان
                        </span>
                      </div>
                    )}

                    <div className={Style.divider} />

                    <div className={Style.payableRow}>
                      <div className={Style.payableLabelGroup}>
                        <span className={Style.payableTitle}>
                          هزینه نهایی قابل پرداخت:
                        </span>
                      </div>
                      <span className={Style.payableAmount}>
                        {separate(finalPayable)} <small>تومان</small>
                      </span>
                    </div>
                  </div>

                  {/* Payment Button */}
                  <div className={Style.cardFooter}>
                    <button
                      className={Style.payButton}
                      onClick={() => sendToIdPay(item.id)}
                      disabled={disable}
                    >
                      <CreditCard className={Style.btnIcon} />
                      <span>
                        {isPayingThis
                          ? "در حال انتقال به درگاه..."
                          : `پرداخت سفارش (${separate(finalPayable)} تومان)`}
                      </span>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </>
    );
  }

  return (
    <div className={Style.componentHolder}>
      <BurgerMenuTitle title={"سبد خرید"} />
      {content}
    </div>
  );
};

export default WaitingForPay;
